import { $api } from './interceptor';
import { IRebalanceResponse } from 'views/types/rebalanceCenter';

export interface IRebalanceParams {
  status?: string;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}

const rebalanceCenterApi = () => {
  const getRebalances = async (params: IRebalanceParams) => {
    const { data } = await $api.get<IRebalanceResponse>(
      '/api/admin/rebalance-transfers',
      { params }
    );
    return data;
  };

  const retry = async (id: string) =>
    (await $api.post(`/api/admin/rebalance-transfers/${id}/retry`)).data;

  return {
    getRebalances,
    retry,
  };
};

export const rebalanceCenterService = rebalanceCenterApi();
